import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { LocalStorageService } from 'src/app/services/local/local-storage.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-setup-complete',
    templateUrl: './setup-complete.component.html',
    styleUrls: ['./setup-complete.component.scss'],
    standalone: false
})
export class SetupCompleteComponent implements OnInit, OnDestroy {
  private _timeoutId: any;

  constructor(
    private _localStorageService: LocalStorageService,
    private _loaderService: NgxUiLoaderService,
  ) { }

  ngOnDestroy(): void {
    if (this._timeoutId) {
      clearTimeout(this._timeoutId);
    }
  }

  ngOnInit(): void {
    const employee = this._localStorageService.getRegEmployee()
    this._loaderService.start();

    this._timeoutId = setTimeout(() => {
      window.location.href = `${environment.authHost}?email=${employee?.emailAddress}`;

      this._loaderService.stop();
    }, 1000);

    this._localStorageService.removeRegEmployee()
  }

}
